import {Component} from '@angular/core';

@Component({
  selector: 'app-enrollment-illustration',
  templateUrl: './enrollment-illustration.component.html'
})
export class EnrollmentIllustrationComponent {
}
